var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-input",
    {
      staticClass: "input-with-select",
      class: { "input-with-select--open": _vm.focused },
      attrs: { placeholder: _vm.placeholder },
      on: {
        blur: function($event) {
          return _vm.$emit("blur")
        }
      },
      model: {
        value: _vm.input,
        callback: function($$v) {
          _vm.input = $$v
        },
        expression: "input"
      }
    },
    [
      _c(
        "el-select",
        {
          attrs: { slot: _vm.selectPosition },
          on: {
            "visible-change": function($event) {
              _vm.focused = !_vm.focused
            }
          },
          slot: _vm.selectPosition,
          model: {
            value: _vm.select,
            callback: function($$v) {
              _vm.select = $$v
            },
            expression: "select"
          }
        },
        _vm._l(_vm.options, function(option) {
          return _c("el-option", {
            key: option.value,
            attrs: { label: option.label, value: option.value }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }